import styled, { keyframes } from "styled-components"

export const OrderSearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`

export const Title = styled.h2`
  color: #333;
  text-align: center;
`

/* ── Loading overlay ── */

const spin = keyframes`
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const pulse = keyframes`
  0%, 100% { opacity: 0.4; transform: scale(0.95); }
  50%      { opacity: 1;   transform: scale(1); }
`

const progressSlide = keyframes`
  0%   { left: -40%; }
  100% { left: 100%; }
`

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
`

export const LoadingOverlay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 24px;
  animation: ${fadeIn} 0.4s ease-out;
`

export const SpinnerRing = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 4px solid #e8e0f3;
  border-top-color: #7b2d8e;
  animation: ${spin} 0.9s linear infinite;
`

export const LoadingTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  animation: ${pulse} 2.4s ease-in-out infinite;
`

export const LoadingTitle = styled.p`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #4a266a;
`

export const LoadingSubtitle = styled.p`
  margin: 0;
  font-size: 15px;
  color: #888;
`

export const ProgressBarTrack = styled.div`
  position: relative;
  width: 220px;
  height: 4px;
  background: #ede7f3;
  border-radius: 4px;
  overflow: hidden;
`

export const ProgressBarFill = styled.div`
  position: absolute;
  top: 0;
  width: 40%;
  height: 100%;
  background: linear-gradient(90deg, #7b2d8e, #a855f7);
  border-radius: 4px;
  animation: ${progressSlide} 1.4s ease-in-out infinite;
`
